import { render, staticRenderFns } from "./primaryGroup.vue?vue&type=template&id=163c1d82&"
import script from "./primaryGroup.vue?vue&type=script&lang=js&"
export * from "./primaryGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/dataPanel/primaryGroup.vue"
export default component.exports